var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameReq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0095DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1330_9984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0375 4H16C14.3638 4 13.0375 5.32385 13.0375 6.96246V20.5187C13.0375 21.0938 13.6971 21.4302 14.1625 21.0812L16.9875 18.9625H25.0375C26.6738 18.9625 28 17.6386 28 16V6.96246C28 5.32623 26.6761 4 25.0375 4ZM19.8156 15.1969H16.7531C16.3647 15.1969 16.05 14.8821 16.05 14.4938C16.05 14.1054 16.3647 13.7906 16.7531 13.7906H19.8156C20.2039 13.7906 20.5187 14.1054 20.5187 14.4938C20.5187 14.8821 20.2039 15.1969 19.8156 15.1969ZM24.2844 12.1844H16.7531C16.3647 12.1844 16.05 11.8695 16.05 11.4813C16.05 11.093 16.3647 10.7782 16.7531 10.7782H24.2844C24.6726 10.7782 24.9875 11.093 24.9875 11.4813C24.9875 11.8695 24.6728 12.1844 24.2844 12.1844ZM24.2844 9.17181H16.7531C16.3647 9.17181 16.05 8.85706 16.05 8.46869C16.05 8.08051 16.3647 7.76556 16.7531 7.76556H24.2844C24.6726 7.76556 24.9875 8.08051 24.9875 8.46869C24.9875 8.85706 24.6728 9.17181 24.2844 9.17181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7924 18.6203C11.7924 20.4559 10.3043 21.944 8.46869 21.944C6.63306 21.944 5.14496 20.4559 5.14496 18.6203C5.14496 16.7845 6.63306 15.2964 8.46869 15.2964C10.3043 15.2964 11.7924 16.7845 11.7924 18.6203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.46869 21.944C6.00079 21.944 4 23.9448 4 26.4127V27.2969C4 27.6852 4.31476 28 4.70312 28H12.2344C12.6226 28 12.9376 27.6852 12.9376 27.2969V26.4127C12.9376 23.9448 10.9368 21.944 8.46869 21.944Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1330_9984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameReq);
export default __webpack_public_path__ + "static/media/game-req.802c38b2153fd187cb9d0cb6e5757784.svg";
export { ForwardRef as ReactComponent };